import type { ComponentPropsWithRef, ReactNode } from "react";
import { forwardRef } from "react";
import { BlockSection } from "@/react/components/shared/BuilderUI/BlockSection";
import { useTopBlockStyles } from "../../../Hooks/useTopBlockStyles";
import type { StyleValue } from "../../../StyleValue.types";
import { salesSecondaryBlockDefaultStyles } from "../constants";

export interface SalesBlock9Props
  extends Omit<ComponentPropsWithRef<"div">, "content"> {
  content?: ReactNode;
  footer?: ReactNode;
  header?: ReactNode;
  styles?: Record<string, StyleValue>;
}

export const SalesBlock9 = forwardRef<HTMLDivElement, SalesBlock9Props>(
  ({ header, content, footer, className, styles, ...rest }, ref) => {
    const { backgroundStyles, paddingStyles, marginStyles } = useTopBlockStyles(
      {
        styles,
        defaultStyles: salesSecondaryBlockDefaultStyles,
      },
    );

    return (
      <BlockSection ref={ref} className={className} {...rest}>
        <BlockSection.Background
          className="wb-bg-secondary"
          style={backgroundStyles}
        >
          <BlockSection.Container>
            <BlockSection.Content
              style={{
                ...paddingStyles,
                ...marginStyles,
              }}
            >
              <BlockSection.NestedBlock className="wb-mx-auto wb-flex wb-max-w-3xl wb-flex-col wb-items-center wb-gap-4 wb-text-center md:wb-gap-6">
                {header}
              </BlockSection.NestedBlock>
              <BlockSection.NestedBlock className="wb-flex wb-flex-col wb-items-center wb-gap-6 md:wb-grid md:wb-grid-cols-3 md:wb-gap-[1.875rem]">
                {content}
              </BlockSection.NestedBlock>
              <BlockSection.NestedBlock
                block={footer}
                render={block => (
                  <div className="wb-flex wb-flex-col wb-items-center wb-gap-4 md:wb-gap-8">
                    <div className="wb-mx-auto wb-flex wb-flex-col wb-justify-center wb-gap-10 md:wb-gap-16">
                      {block}
                    </div>
                  </div>
                )}
              />
            </BlockSection.Content>
          </BlockSection.Container>
        </BlockSection.Background>
      </BlockSection>
    );
  },
);

SalesBlock9.displayName = "SalesBlock9";
